

const ViewBody = () => {
    return (
        <div className="col-span-3 md:col-span-4 p-5">
            <div className="bg-[#1E1F25] rounded-xl h-full">
                
            </div>
        </div>
    )
}

export default ViewBody;